import { toast } from "react-toastify";
import API from "../../Api/Api";
import { API_END_POINT } from "../../Api/EndPoints";
import NEW_API from "../../Api/NewApi";
import { isDefined } from "../../Utils";
import { closeCenteredModal } from "./centeredModal";

const errors = [
  "email must be a valid email",
  "password must be at least 6 characters",
  "Email or Username are already taken",
];

export const fetchDepots =
  (page = 1, search = "", filters = {}, signal) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_DEPOTS_LOADING" });
    try {
      const query = {
        pagination: {
          page: page,
          pageSize: 10,
        },
        populate: {
          address: {
            populate: {
              country: true,
              city: true,
            },
          },
          storekeepers: {
            populate: {
              user: true,
            },
          },
        },
        filters: {
          ...(search && {
            $or: [
              { name: { $containsi: search } },
              { code: { $containsi: search } },
              { email: { $containsi: search } },
              { phone: { $containsi: search } },
            ],
          }),
          ...filters,
        },
      };

      const { data } = await API.get(`${API_END_POINT}api/entrepots`, {
        signal,
        params: query,
      });

      if (page === 1) {
        dispatch({
          type: "FETCH_DEPOTS_SUCCESS",
          payload: {
            data: data?.data,
            meta: data?.meta,
          },
        });
      } else {
        dispatch({
          type: "FETCH_DEPOTS_LOAD_MORE_SUCCESS",
          payload: {
            data: data?.data,
            meta: data?.meta,
          },
        });
      }
    } catch (error) {
      if (error.name === "CanceledError" || error.code === "ERR_CANCELED")
        return;
      console.log(error);
      dispatch({ type: "FETCH_DEPOTS_ERROR", payload: error });
    }
  };

export const fetchDepotById = (id) => async (dispatch) => {
  dispatch({ type: "FETCH_DEPOT_LOADING" });
  try {
    const params = {
      populate: {
        address: {
          populate: {
            country: true,
            city: true,
          },
        },
        storekeepers: {
          populate: {
            user: true,
          },
        },
      },
    };
    const { data } = await API.get(`${API_END_POINT}api/entrepots/${id}`, {
      params,
    });
    dispatch({ type: "FETCH_DEPOT_SUCCESS", payload: data?.data });
  } catch (error) {
    console.log(error);
    dispatch({ type: "FETCH_DEPOT_ERROR", payload: error });
  }
};

export const refetchDepot = (id) => async (dispatch) => {
  try {
    const params = {
      populate: {
        address: {
          populate: {
            country: true,
            city: true,
          },
        },
        storekeepers: {
          populate: {
            user: true,
          },
        },
      },
    };
    const { data } = await API.get(`${API_END_POINT}api/entrepots/${id}`, {
      params,
    });

    dispatch({ type: "REFETCH_DEPOT_SUCCESS", payload: data?.data });
  } catch (error) {
    console.log(error);
    dispatch({ type: "REFETCH_DEPOT_ERROR", payload: error });
  }
};

export const createDepot =
  (depotData, t, callback) => async (dispatch, getState) => {
    dispatch({ type: "CREATE_DEPOT_LOADING" });
    try {
      const user = getState().userReducer.user;
      const createDepot = await API.post(`${API_END_POINT}api/entrepots`, {
        data: {
          ...depotData,
          marque: user?.attributes?.marque?.data?.id,
        },
      });

      const { data } = await API.get(
        `${API_END_POINT}api/entrepots/${createDepot?.data?.data?.id}`,
        {
          params: {
            populate: {
              address: {
                populate: {
                  country: true,
                  city: true,
                },
              },
              storekeepers: {
                populate: {
                  user: true,
                },
              },
            },
          },
        },
      );
      dispatch({ type: "CREATE_DEPOT_SUCCESS", payload: data?.data });
      callback();
      return data?.data;
    } catch (error) {
      console.log(error);
      dispatch({ type: "CREATE_DEPOT_ERROR", payload: error });
      if (errors?.includes(error?.response?.data?.error?.message)) {
        toast.error(t(`${error?.response?.data?.error?.message}`));
      } else {
        toast.error(t("An error has occurred!"));
      }
    }
  };

export const updateDepot =
  (id, depotData, t, callback) => async (dispatch, getState) => {
    const user = getState().userReducer.user;
    dispatch({ type: "UPDATE_DEPOT_LOADING" });
    try {
      await API.put(`${API_END_POINT}api/entrepots/${id}`, {
        data: {
          ...depotData,
          marque: user?.attributes?.marque?.data?.id,
        },
      });

      const { data } = await API.get(`${API_END_POINT}api/entrepots/${id}`, {
        params: {
          populate: {
            address: {
              populate: {
                country: true,
                city: true,
              },
            },
            storekeepers: {
              populate: {
                user: true,
              },
            },
          },
        },
      });
      dispatch({ type: "UPDATE_DEPOT_SUCCESS", payload: data?.data });
      callback();
      return data?.data;
    } catch (error) {
      console.log(error);
      dispatch({ type: "UPDATE_DEPOT_ERROR", payload: error });
      if (errors?.includes(error?.response?.data?.error?.message)) {
        toast.error(t(`${error?.response?.data?.error?.message}`));
      } else {
        toast.error(t("An error has occurred!"));
      }
    }
  };

export const deleteDepot = (id, t) => async (dispatch) => {
  dispatch({ type: "DELETE_DEPOT_LOADING" });
  try {
    await API.delete(`${API_END_POINT}api/depots/${id}`);
    dispatch({ type: "DELETE_DEPOT_SUCCESS", payload: id });
    return id;
  } catch (error) {
    console.log(error);
    dispatch({ type: "DELETE_DEPOT_ERROR", payload: error });
    if (errors.includes(error?.response?.data?.error?.message)) {
      toast.error(t(`${error?.response?.data?.error?.message}`));
    } else {
      toast.error(t("An error has occurred!"));
    }
  }
};

// export const fetchStorekeepersByDepot = (depotId) => async (dispatch) => {
//   dispatch({ type: "FETCH_DEPOT_STOREKEEPERS_LOADING" });
//   try {
//     const query = {
//       filters: {
//         depot: {
//           id: { $eq: depotId },
//         },
//       },
//       populate: "*",
//     };
//     const { data } = await API.get(`${API_END_POINT}api/storekeepers`, {
//       params: query,
//     });
//     dispatch({ type: "FETCH_DEPOT_STOREKEEPERS_SUCCESS", payload: data?.data });
//   } catch (error) {
//     console.log(error);
//     dispatch({ type: "FETCH_DEPOT_STOREKEEPERS_ERROR", payload: error });
//   }
// };

// Clear depot data
export const clearDepotData = () => (dispatch) => {
  dispatch({ type: "CLEAR_DEPOT_DATA" });
};

// Set selected depot
// export const setSelectedDepot = (depot) => (dispatch) => {
//   dispatch({ type: "SET_SELECTED_DEPOT", payload: depot });
// };

const createCity = async (payload) => {
  const newCity = await NEW_API.post("/api/cities", {
    data: {
      name: payload.city,
      country: payload.country.code,
      zipCode: payload.zip,
      code: payload?.code,
    },
  });
  return newCity.data.data.id;
};

const updateCity = async (cityId, payload) => {
  const newCity = await NEW_API.put(`/api/cities/${cityId}`, {
    data: {
      name: payload.city.name,
      country: payload.country.code,
      zipCode: payload.zip,
      code: payload.code,
    },
  });
  return newCity.data.data.id;
};

export const createAddress = (payload, depotId, t) => async (dispatch) => {
  const relationType = { entrepot: depotId || null };

  let cityId = payload.city.code;
  if (!cityId) {
    cityId = await createCity(payload);
  } else {
    await updateCity(cityId, payload);
  }

  try {
    await API.post(`api/addresses`, {
      data: {
        name: payload.name,
        street: payload.street,
        zip: payload.zip,
        country: payload.country.code,
        city: cityId,
        ...relationType,
      },
    });

    if (isDefined(depotId)) {
      dispatch(refetchDepot(depotId));
    }

    dispatch(closeCenteredModal());

    toast.success(t("Address successfully created"));
  } catch (error) {
    toast.error(t("An error has occurred!"));
    console.log(error);
  }
};

export const updateAdress =
  (addressId, payload, depotId, t) => async (dispatch) => {
    let cityId = payload.city.code;

    if (!cityId) {
      cityId = await createCity(payload);
    } else {
      await updateCity(cityId, payload);
    }

    try {
      await API.put(`api/addresses/${addressId}`, {
        data: {
          name: payload.name,
          street: payload.street,
          zip: payload.zip,
          country: payload.country.code,
          city: cityId,
          depot: depotId,
        },
      });
      if (isDefined(depotId)) {
        dispatch(refetchDepot(depotId));
      }

      dispatch(closeCenteredModal());

      toast.success(t("Address successfully updated"));
    } catch (error) {
      toast.error(t("An error has occurred!"));
      console.log(error);
    }
  };
